// @ts-check
import { createDataGridContext } from '~/components/Shared/ZeroDataGrid/ZeroDataGrid.context';
import { useCallback, useContext, useMemo, useState } from "react";

export const [TaskDataGridContext, TaskDataGridContextProvider] = createDataGridContext('tasks', useContextValue);

export function useTaskDataGridContext() {
    return useContext(TaskDataGridContext);
}

const initialFilterState = {
    search: '',
    period: '',
    status: '',
    allTasks: '',
}

function useContextValue() {
    const [filters, setFilters] = useState(initialFilterState);

    const setFilter = useCallback((key, value) => {
        setFilters(filters => ({...filters, [key]: value}));
    }, [setFilters]);

    return useMemo(() => ({filters, setFilter}), [filters, setFilter]);
}